export const KEYCODE_ENTER = 13;
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const MAX_QUOTATION = 15;
